import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Diamond, Rocket } from "components/icons";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { useUserDataContext } from "context/UserDataContext";
import { useNavigate } from "react-router-dom";
import { SubscriptionType } from "types/enums";
import { getColorByMode } from "utils";

interface IProps {
  size?: "small" | "normal";
  disable?: boolean;
  subscription?: SubscriptionType;
}

export const StyledSubscriptionBox = styled(Box)<{
  subscriptionType?: SubscriptionType;
  size?: "small" | "normal";
  disable?: boolean;
}>(({ theme, subscriptionType, size, disable }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    borderRadius: "12px",
    padding: theme.spacing(size === "small" ? 0.5 : 1, size === "small" ? 1 : 2),
    fontWeight: fontWeight.semiBold,
    fontSize: size === "small" ? "0.75rem" : "0.9735rem",
    display: "flex",
    alignItems: "center",
    gap: size === "small" ? theme.spacing(0.5) : theme.spacing(1),
    cursor: disable ? "default" : "pointer",

    ...(subscriptionType === SubscriptionType.FREE && {
      backgroundColor: colors.lightMint,
      color: getColorByMode(theme, colors.deepMidnightBlue, colors.black),
    }),
    ...(subscriptionType === SubscriptionType.PREMIUM && {
      backgroundColor: colors.violet,
      color: colors.white,
    }),
    ...(subscriptionType === SubscriptionType.PRO && {
      backgroundColor: colors.charcoalGray,
      color: colors.white,
    }),

    ...(!disable && {
      "&:hover": {
        transform: "scale(1.02)",
      },
    }),
  };
});

const SubscriptionBadge = ({ size = "normal", disable = false, subscription }: IProps) => {
  const navigate = useNavigate();
  const { subscriptionType: userSubscriptionType } = useUserDataContext();
  const subscriptionType = subscription || userSubscriptionType;

  const getIcon = () => {
    if (subscriptionType === SubscriptionType.PREMIUM) return <Rocket sx={{ fontSize: size === "small" ? "1rem" : "1.5rem" }} />;
    if (subscriptionType === SubscriptionType.PRO) return <Diamond sx={{ fontSize: size === "small" ? "1rem" : "1.5rem" }} />;

    return null;
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (disable) return;

    event.stopPropagation();
    event.preventDefault();

    navigate("/stosaky");
  };

  return (
    <StyledSubscriptionBox subscriptionType={subscriptionType} size={size} onClick={handleClick} disable={disable}>
      {getIcon()}
      {subscriptionType}
    </StyledSubscriptionBox>
  );
};

export default SubscriptionBadge;
